export default __webpack_public_path__ + "static/mobile-bg-120be0238d6c2518033e947a8653dbfa.mp4";